import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import type { NotificationFindInterface } from '@zaoblako/shared/modules/notification/dtos/notification-find.dto';
import { SafeHtmlPipe } from '@zaoblako/web/shared/pipes/safe-html.pipe';
import { ButtonComponent } from '@zaoblako/web/shared/dumbs/button/button.component';
import { CheckboxModule } from 'primeng/checkbox';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  standalone: true,
  selector: 'crm-changelog-version',
  templateUrl: './changelog-version.component.html',
  imports: [CommonModule, ButtonComponent, SafeHtmlPipe, CheckboxModule, FormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChangelogVersionComponent implements OnDestroy {
  public changelog: NotificationFindInterface;
  public isShowClose: boolean = true;
  public data: { isRemoveModal: boolean } = {
    isRemoveModal: false
  };

  public constructor(
    public readonly ref: DynamicDialogRef,
    private readonly cdRef: ChangeDetectorRef,
    private readonly config: DynamicDialogConfig
  ) {
    this.changelog = config.data?.changelog;
  }

  public ngOnDestroy() {
    this.ref?.close(this.data);
  }
}
